export default {
    /* GET_STOP_CARDS
    ---------------------------------------------------------------
    */
    GET_STOP_CARDS_REQUEST: state => {
        state.stopCardsLoading = true
    },
    GET_STOP_CARDS_SUCCESS: (state, data) => {
        state.stopCards = data.results
        state.stopCardsLoading = false
    },
    GET_STOP_CARDS_FAILURE: state => {
        state.stopCardsLoading = false
    },
    /* GET_STOP_CARDS
    ---------------------------------------------------------------
    */
    GET_ERRORS_SUCCESS: (state, data) => {
        state.errors = data.results
    },
    GET_STOP_CARDS_STATUSES_SUCCESS: (state, data) => {
        state.statuses = data.results
    },
    SET_STOP_CARDS_FILTERS: (state, filters) => {
        state.filters = filters
    },
    CLEAR_STOP_CARDS_FILTERS: state => {
        state.filters = state.setInitialStopCardsFilters()
    },
    GET_WAYS_OF_CLOSING_SUCCESS: (state, data) => {
        state.waysOfClosing = data.results
    },
}